/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Credit_Packs_TitleInputs */

const en_agb_credit_packs_title = /** @type {(inputs: Agb_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6a. Credit Packs`)
};

const de_agb_credit_packs_title = /** @type {(inputs: Agb_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6a. Credit-Pakete`)
};

const fr_agb_credit_packs_title = /** @type {(inputs: Agb_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6a. Packs de credits`)
};

const es_agb_credit_packs_title = /** @type {(inputs: Agb_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6a. Paquetes de creditos`)
};

const it_agb_credit_packs_title = /** @type {(inputs: Agb_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6a. Pacchetti di crediti`)
};

const nl_agb_credit_packs_title = /** @type {(inputs: Agb_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6a. Creditpakketten`)
};

const pl_agb_credit_packs_title = /** @type {(inputs: Agb_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6a. Paczki kredytow`)
};

const fi_agb_credit_packs_title = /** @type {(inputs: Agb_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6a. Krediittipaketit`)
};

const da_agb_credit_packs_title = /** @type {(inputs: Agb_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6a. Kreditpakker`)
};

const sv_agb_credit_packs_title = /** @type {(inputs: Agb_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6a. Kreditpaket`)
};

/**
* | output |
* | --- |
* | "6a. Credit Packs" |
*
* @param {Agb_Credit_Packs_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_credit_packs_title = /** @type {((inputs?: Agb_Credit_Packs_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Credit_Packs_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_credit_packs_title(inputs)
	if (locale === "fr") return fr_agb_credit_packs_title(inputs)
	if (locale === "es") return es_agb_credit_packs_title(inputs)
	if (locale === "it") return it_agb_credit_packs_title(inputs)
	if (locale === "nl") return nl_agb_credit_packs_title(inputs)
	if (locale === "pl") return pl_agb_credit_packs_title(inputs)
	if (locale === "fi") return fi_agb_credit_packs_title(inputs)
	if (locale === "da") return da_agb_credit_packs_title(inputs)
	if (locale === "sv") return sv_agb_credit_packs_title(inputs)
	return en_agb_credit_packs_title(inputs)
});